import React from "react";
import { toColumnLabel } from "../../utils/columnUtils";
import "./styles/sort.css";

/**
 * ColumnHeader
 * Single `<th>` in the table's thead — shows the column letter (A, B, …),
 * the column-resize handle, and a small sort-direction arrow when the
 * column participates in the sort.  The arrow lives HERE (not on the
 * row-1 filter dropdown) because the column-letter header is always
 * visible on every sheet, even when the data's own header sits on a lower
 * row or the column has no filter dropdown.  The Sort + Filter dropdown
 * itself lives on the first data row's cell (see FilterButton).
 */
function ColumnHeader({
  colIndex, className, style, sortState,
  onSelect, onExtend, onContextMenu, onStartResize,
}) {
  const sortDir = sortState ? sortState.dir : null;
  const sortRank = sortState ? sortState.rank : 0;

  return (
    <th
      className={className}
      style={style}
      onMouseDown={(e) => { if (e.button === 0) onSelect(colIndex, e); }}
      onMouseEnter={() => onExtend(colIndex)}
      onContextMenu={onContextMenu}
    >
      {toColumnLabel(colIndex)}
      {sortDir && (
        <span
          className="sev-colhdr-sort"
          title={sortDir === "asc" ? "Sorted A → Z" : "Sorted Z → A"}
        >
          <span className="material-icons">
            {sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
          </span>
          {sortRank > 0 && <span className="sev-colhdr-sort-rank">{sortRank}</span>}
        </span>
      )}
      <span className="sev-resize-col" onMouseDown={(event) => onStartResize("col", colIndex, event)} />
    </th>
  );
}

export default React.memo(ColumnHeader);
